export interface CatalogFilter {
  itemId?: string;
  itemid?: string;
  property: string;
  type: 'str';
  sign: 'equal';
  value: string;
  description: string;
  Conjuntion?: 'AND';
}

export const SORT_BY_VALUE = JSON.stringify({
  property: 'Value',
  direction: 'ASC',
});

interface FilterOptions {
  /** The backend expects the key spelled `itemid` (not `itemId`) for the brands catalog. */
  lowercaseItemId?: boolean;
  conjunction?: boolean;
}

export const equalFilter = (
  property: string,
  value: string,
  options: FilterOptions = {}
): CatalogFilter => {
  const filter: CatalogFilter = {
    property,
    type: 'str',
    sign: 'equal',
    value,
    description: '',
  };
  const keyed = options.lowercaseItemId
    ? { itemid: property, ...filter }
    : { itemId: property, ...filter };
  return options.conjunction ? { ...keyed, Conjuntion: 'AND' } : keyed;
};
